// Pure helpers for the Holidays page — kept separate from the sheet-shape
// decoration and from annualDates.js, which owns the actual month/day math
// shared with birthdays/anniversaries/recurring announcements.
import { formatAnnualDate } from './annualDates';

// "Dec 25" — holidays are stored 1-12 (human-friendly, matches the
// create/edit form), but annualDates.js's month math is 0-11 (JS Date
// convention), same adapter used by utils/announcements.js.
export function formatHolidayDate(h) {
  return formatAnnualDate(Number(h.month) - 1, Number(h.day));
}

// Holidays sorted by where they fall in the calendar year (Jan first),
// independent of the current date — this is a reference list, not a
// countdown, so "soonest from today" isn't the right order here.
export function sortHolidaysByDate(holidays) {
  return [...holidays].sort((a, b) => {
    const am = Number(a.month), bm = Number(b.month);
    if (am !== bm) return am - bm;
    return Number(a.day) - Number(b.day);
  });
}

// Every Holiday a HolidayListItems join maps to a given list_id, sorted the
// same way as the main Holidays section.
export function holidaysForList(listId, holidays, holidayListItems) {
  const idsInList = new Set(
    holidayListItems.filter((item) => item.list_id === listId).map((item) => item.holiday_id)
  );
  return sortHolidaysByDate(holidays.filter((h) => idsInList.has(h.holiday_id)));
}
